import * as React from 'react';

import { Tags } from './Tags';
import { Features } from './Features';
import { ControlsContainer as Controls } from './Controls';
import { Polygons } from './Polygons';

interface IMapModulesProps {
  ymaps: YMaps.IYMaps | null | undefined;
  map: YMaps.Map | null | undefined;
}

export function MapLayers({ ymaps, map }: IMapModulesProps) {
  if (!ymaps || !map) {
    return null;
  }

  return (
    <>
      <Tags />
      <Features />
      <Controls />
      <Polygons ymaps={ymaps} map={map} />
    </>
  );
}
